import { debounce } from 'lodash'

export default {
  mounted() {
    this.debouncedHandleScrollResize = debounce(this.handleScrollResize, 100)

    window.addEventListener('resize', this.debouncedHandleScrollResize)
    window.addEventListener('scroll', this.debouncedHandleScrollResize, true)
  },
  beforeDestroy() {
    // Remove the stored debounced function
    window.removeEventListener('resize', this.debouncedHandleScrollResize)
    window.removeEventListener('scroll', this.debouncedHandleScrollResize, true)

    // Cancel the debounced function to clean up
    this.debouncedHandleScrollResize.cancel()
  },
  methods: {
    handleScrollResize () {
      if (this.$refs[this.assignDropdownRef].$children[0]?.$refs?.menu.isActive) { // menu is visible
        this.positionMenuDropdown()
      }
    },
    positionMenuDropdown() {
      this.$nextTick(() => {
        setTimeout(() => {
          const dropdown = this.$refs[this.assignDropdownRef]
          const menu = dropdown?.$children[0]?.$refs?.menu?.$children[0]?.$el
          const activator = dropdown?.$el

          if (!menu || !activator) return

          const activatorRect = activator.getBoundingClientRect()
          const viewportHeight = window.innerHeight
          const menuHeight = menu.offsetHeight

          const spaceBelow = viewportHeight - activatorRect.bottom
          const spaceAbove = activatorRect.top

          if (spaceBelow >= menuHeight) {
            menu.style.top = `${activatorRect.height}px`
          } else if (spaceAbove >= menuHeight) {
            menu.style.top = `-${menuHeight}px`
          } else {
            const maxHeight = Math.max(spaceBelow, spaceAbove)
            menu.style.maxHeight = `${maxHeight}px`

            if (spaceBelow >= spaceAbove) {
              menu.style.top = `${activatorRect.height}px`
            } else {
              menu.style.top = `-${maxHeight}px`
            }
          }

          menu.style.setProperty('--visibility', 'visible')
        }, 40) // this allows for the DOM to fully update
      })
    }
  }
}
